module.exports = __webpack_public_path__ + "images/category_lp/common/pop-attention_06917cd0c06153ab81d72dee270eb3ed.png";